import React from "react";

const Imprint = () => {
  return (
    <div className="content">
      <h1 className="title">Impressum</h1>
      <p>
        <b>V.i.S.d.P: (folgt)</b>
      </p>
      <p>
        Der Köln-Atlas ist eine Geo-Anwendung auf Basis von Open
        Source-Technologien und wurde von Stefan T. Oertel (
        <a href="https://oertel.it">https://oertel.it</a>) entwickelt und
        umgesetzt.
      </p>

      <h2 className="subtitle">Netzwerk e.V.</h2>
      <p>
        Ludger Brauckhoff
        <br />
        Longericher Straße 136
        <br />
        50739 Köln-Bilderstöckchen
        <br />
        E-Mail: Ludger.Brauckhoff@netzwerk.koeln
        <br />
      </p>

      <h2 className="subtitle">Christliche Sozialhilfe Köln e.V.</h2>
      <p>
        Nadja Oertel
        <br />
        Knauffstr. 1
        <br />
        51063 Köln-Mülheim
        <br />
        E-Mail: nadja.oertel@csh-koeln.de
        <br />
      </p>

      <h2 className="subtitle">
        Stadt Köln – Interkultureller Dienst im Bezirk Nippes
      </h2>
      <p>
        Eden Araya-Gabriel, Bezirksrathaus
        <br />
        Neusser Straße 450
        <br />
        50733 Köln
        <br />
        E-Mail: Eden.Araya-Gabriel@stadt-koeln.de
        <br />
      </p>

      <h2 className="subtitle">Stadt Köln –Jugendpflege Nippes</h2>
      <p>
        Thomas Berner, Bezirksrathaus
        <br />
        Neusser Straße 450
        <br />
        50733 Köln
        <br />
        E-Mail: thomas.berner@stadt-koeln.de
        <br />
      </p>

      <p>
        Die Schwerpunktträger im Stadtbezirk Nippes DRK, Praxis Jugendhilfe und
        der SKF unterstützen den Köln Atlas.
      </p>

      <h2 className="subtitle">Haftungshinweis</h2>
      <p>
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
        für die Inhalte externer Links. Für die Inhalte der verlinkten Seiten
        sind ausschließlich deren Betreiber verantwortlich.
      </p>

      <h2 className="subtitle">Urheberrecht</h2>
      <p>
        Die Inhalte dieser Seiten sind urheberrechtlich geschützt. Für die
        Veröffentlichung aller Texte und Bilder – gleich auf welchem Medium –
        bedarf es einer schriftlichen Genehmigung.
      </p>
      <p />
    </div>
  );
};

export default Imprint;



/** WEBPACK FOOTER **
 ** ./src/components/Imprint.jsx
 **/